import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getSaleDebitNote,
  getSaleDebitNoteById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  createSaleDebitNote,
  getSaleDebitNoteDetailsById,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  saleDebitNotes: [],
  edit: false,
  saleDebitNote: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSaleDebitNote: false,
  loadingNext: false,
  saleDebitNoteDetails: [
    {
      product: null,
      vendor: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate()),
      unique: uuidv4(),
      noEffectInventory: false,
    },
  ],
  saveAndContinue: false,
  showCreateModal: false,
  selectedSaleInvoice: null,
  selectedSaleInvoiceDetails: [],
};

export const saleDebitNoteSlice = createSlice({
  name: "saleDebitNote",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },

    setSaleInvoice: (state, action) => {
      state.selectedSaleInvoice = action.payload;
    },
    setSelectedInvoiceDetails: (state, action) => {
      state.selectedSaleInvoiceDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },

    setSaleDebitNote: (state, action) => {
      state.saleDebitNote = action.payload;
    },
    saleDebitNoteDetailsUpdated: (state, action) => {
      state.saleDebitNoteDetails = action.payload.map((value) => {
        return { ...value, description: value.product?.name, unique: uuidv4() };
      });
    },
    clearSelectedOrderData: (state) => {
      state.selectedSaleInvoice = null;
      state.selectedSaleInvoiceDetails = [];
    },
    clearSaleDebitNoteDetails: (state) => {
      state.saleDebitNoteDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
          noEffectInventory: false,
        },
      ];
    },
    clearAllSaleDebitNote: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSaleDebitNote = false;
      state.saleDebitNote = null;
      state.selectedSaleInvoice = null;
      state.selectedSaleInvoiceDetails = [];
      state.saleDebitNoteDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
          noEffectInventory: false,
        },
      ];
      state.saveAndContinue = false;
    },
  },
  extraReducers: (builder) => {
    // getSaleDebitNoteById
    builder.addCase(getSaleDebitNoteById.pending, (state) => {
      state.loading = true;
      state.saleDebitNote = null;
    });
    builder.addCase(getSaleDebitNoteById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.saleDebitNote = action.payload.data;
      state.saleDebitNoteDetails = action.payload.data?.drCrNotesDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getSaleDebitNoteById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.saleDebitNote = null;
    });

    builder.addCase(getSaleDebitNoteDetailsById.pending, (state) => {
      state.loading = true;
      state.saleDebitNote = null;
    });
    builder.addCase(getSaleDebitNoteDetailsById.fulfilled, (state, action) => {
      state.loading = false;
      state.saleDebitNote = action.payload.data;
    });
    builder.addCase(getSaleDebitNoteDetailsById.rejected, (state) => {
      state.loading = false;
      state.saleDebitNote = null;
    });

    builder.addMatcher(
      isAnyOf(
        getSaleDebitNote.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingSaleDebitNote = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleDebitNote.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSaleDebitNote = false;
        state.saleDebitNotes = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleDebitNote.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSaleDebitNote = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  setSaleInvoice,
  setSelectedInvoiceDetails,
  setSaleDebitNote,
  saleDebitNoteDetailsUpdated,

  clearSaleDebitNoteDetails,
  clearAllSaleDebitNote,
} = saleDebitNoteSlice.actions;

export default saleDebitNoteSlice.reducer;
